import { Action } from '@ngrx/store';

import { UserTokens } from '@common/entities/user-tokens.entity';

export enum TokenActionTypes {
    Set = '[Token] Set',
    Unset = '[Token] Unset'
}

export class SetTokens implements Action {
    readonly type: TokenActionTypes.Set = TokenActionTypes.Set;
    constructor(public payload: UserTokens) {}
}

export class UnsetTokens implements Action {
    readonly type: TokenActionTypes.Unset = TokenActionTypes.Unset;
}

export type TokenActions = SetTokens | UnsetTokens;
